"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _ErrorIcon = _interopRequireDefault(require("../../ErrorIcon")),
    _styles = require("../styles");

require("../styles/_input-container.scss");

function focusInput(a) {
  a.preventDefault(), a.stopPropagation();
  var b = document.querySelector(".input__element");
  b && b.focus();
}

function getDecorator(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      c = b.isSuffix,
      d = b.isErrorIcon,
      e = b.iconId,
      f = b.errorMessage,
      g = b.prefixCanTakeFocus,
      h = b.disabled;
  if (!a) return null;
  var i = "string" != typeof a;
  if (i && !d && g) return _react["default"].createElement("div", {
    className: "input-container__decorator"
  }, a);
  var j = i ? a : _react["default"].createElement(_Icon["default"], {
    color: h ? "nevada" : "denim",
    name: a,
    size: 15
  }),
      k = d ? _react["default"].createElement(_ErrorIcon["default"], {
    id: e,
    errorMessage: f,
    tooltipProps: {
      place: "left"
    }
  }) : j;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("input-container__decorator", {
      "input-container__decorator--is-suffix": c
    })
  }, _react["default"].createElement("button", {
    className: "input-container__decorator__button",
    type: "button",
    tabIndex: -1,
    onMouseDown: focusInput,
    onClick: focusInput
  }, k));
}

function InputContainer(a) {
  var b = a.children,
      c = a.className,
      d = a.prefix,
      e = a.suffixIcon,
      f = a.valid,
      g = a.errorMessage,
      h = a.id,
      i = a.prefixCanTakeFocus,
      j = a.multiline,
      k = a.disabled,
      l = a.autoGrow,
      m = getDecorator(d, {
    iconId: h,
    prefixCanTakeFocus: i,
    disabled: k
  }),
      n = getDecorator(e, {
    isSuffix: !0,
    isErrorIcon: !f,
    iconId: h,
    errorMessage: g,
    disabled: k
  });
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("input-container", {
      "input-container--multiline": j,
      "input-container--grow": l,
      "input-container--with-prefix": !!m,
      "input-container--with-suffix": !!n
    }, _styles.INPUT_CONTAINER, c)
  }, b, m, n);
}

var _default = (0, _react.memo)(InputContainer);

exports["default"] = _default;